export enum ExchangeType {
  bybit = 'ByBit',
  blofin = 'BloFin'
}
